import { registerCollisionAnimation } from './CollisionAnimationRegistry';
import { SonicBoomAnimation } from '../blasts/SonicBoom';

registerCollisionAnimation('SONIC_WAVE', (ctx, e, config, progress) => {
  SonicBoomAnimation(ctx, e as any, config, progress);
});
